import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Regional} from "../../../shared/interface/regional";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {RegionalService} from "../../../shared/services/regional.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {takeUntil} from "rxjs/operators";
import {HiperioConfigDirect} from "../../../shared/interface/hiperio-config-direct";
import {
  ChangeRegistrationHiperioDialogComponent
} from "../../agents-profile-hiperio/change-registration-dialog/change-registration-hiperio-dialog.component";
import {
  ChangeRegistrationHiperioDirectComponent
} from "../change-registration-hiperio-direct/change-registration-hiperio-direct.component";

@Component({
  selector: 'app-hiperio-config-direct-details-view',
  templateUrl: './hiperio-config-direct-details-view.component.html',
  styleUrls: ['./hiperio-config-direct-details-view.component.scss']
})
export class HiperioConfigDirectDetailsViewComponent implements  OnInit, OnDestroy {
  @Input() hiperioConfigDirect: Observable<HiperioConfigDirect>;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;
  hiperioConfigDirectObject?: HiperioConfigDirect;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private regionalService: RegionalService,
    private snack: MatSnackBar,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.hiperioConfigDirect
      .pipe(takeUntil(this.destroyed$))
      .subscribe((hiperioConfigDirect: HiperioConfigDirect) => {
        this.hiperioConfigDirectObject = hiperioConfigDirect;
      });
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  modifyRegistration(): void {
      const dialogRef = this.dialog.open(ChangeRegistrationHiperioDirectComponent, {
        width: '80vw',
        maxHeight: '90vh',
        data: {
          insuranceCompany: this.hiperioConfigDirectObject.insuranceCompany,
          hiperioConfigDirectId: this.hiperioConfigDirectObject.id ,
          registration: this.hiperioConfigDirectObject.registration
        },
      });

      dialogRef.afterClosed().subscribe(() => {
        this.modifyClicked.emit();
      });
  }
}
